import PropTypes from 'prop-types';
import { CheckBoxGroup } from '@medifind/shared-basic-components';
import { areFilterStatesEqual } from '@medifind/zustand';
import { Filter } from './Filter';

const StoreFilterFieldSingleRadio = ({ filter = {}, onValueChange, onClear, classes = {}, label = '', what, smallAt }) => {
  const { options, selected, getInitialState, setFilterValue, reset } = filter;
  return (
    <Filter
      classes={classes}
      label={label}
      what={what}
      smallAt={smallAt}
      placeholder={selected && selected.display}
      onClear={() => {
        reset && reset();
        onClear && onClear();
      }}
      isChanged={!areFilterStatesEqual(getInitialState(), filter)}
    >
      <CheckBoxGroup
        selectedValues={[selected]}
        initialValue={options}
        items={options}
        type="radio"
        onChange={(...args) => {
          setFilterValue && setFilterValue(...args);
          onValueChange && onValueChange(...args);
        }}
      />
    </Filter>
  );
};

StoreFilterFieldSingleRadio.propTypes = {
  filter: PropTypes.any.isRequired,
  onValueChange: PropTypes.func,
  onClear: PropTypes.func,
  what: PropTypes.node,
  classes: PropTypes.object,
  label: PropTypes.string,
  smallAt: PropTypes.string,
  showFilterClearButton: PropTypes.bool,
};

export { StoreFilterFieldSingleRadio as default, StoreFilterFieldSingleRadio };
